export interface InterfaceExpense {
    id: string,
    project: string,
    fieldingRequestId: string,
    fieldingRequest: string,
    createdDate: string,
    createdDateString: string,
    createdById: string,
    createdBy: string,
    status: number,
    statusString: string,
    notes: string,
    amount: number
    docNumber: string,
    processedDate: string,
    processedDateString: string,
    total?: number,
    invoiceNumber?: string,
}

export enum BillingStatus {
    Pending = 0,
    Paid,
    Rejected,
    Approved
}

export interface InterfaceExpenseCreate {
    fieldingRequestId?: string,
    amount: string,
    notes: string,
    docNumber?: string,
    processedDate?: string | null,
}

export interface InterfaceExpenseUpdate {
    id: string,
    amount: string,
    notes: string,
    removedAttachmentIds: Array<string>,
    processedDate?: string | null,
}

export interface InterfaceExpenseDetail extends InterfaceExpense {
    attachments: {
        id: string,
        fileName: string,
        filePath: string
    }[],
    modifiedDate: string,
    modifiedDateString: string,
    approvalMessage: string,
    invoiceNumber?: string,
    total?: number,
    billings?: {
        id: string,
        createdDate: string,
        createdDateString: string,
        amount: number,
        notes: string,
        fielder: string
    }[]
}

export interface InterfaceExpenseGet {
    skip: number,
    take: number,
    startDateString: string,
    endDateString: string,
    filter: string,
    status: number,
    fielderId: string
}

export interface InterfacePaidBillingGet {
    skip: number,
    take: number,
    startDateString: string,
    endDateString: string,
    filter: string,
    fielderId: string
}

export const InitialExpenseGet: InterfaceExpenseGet = {
    skip: 0,
    take: 50,
    startDateString: '',
    endDateString: '',
    filter: '',
    status: 0,
    fielderId: ''
}

export const InitialExpenseCreate: InterfaceExpenseCreate = {
    amount: '0',
    notes: '',
    docNumber: '',
    processedDate: ''
}

export interface InterfaceMileage {
    project: string;
    fieldingRequest: string;
    assignedFielder: string;
    lastUpdate: string;
    mileage: string;
}

export interface InterfaceMileageGet {
    filter: string,
    filterStartDate: string,
    filterEndDate: string,
    fielderId: string,
    projectStatus?: number
}

export const InitialMileageGet: InterfaceMileageGet = {
    filter: '',
    filterStartDate: '',
    filterEndDate: '',
    fielderId: '',
    projectStatus: 0
}